import { utils } from "xlsx"
import type { CellObject, WorkBook, WorkSheet } from "xlsx"

export const XLSX_CONTENT_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"

export function toUint8Array(buffer: Buffer): Uint8Array {
  return new Uint8Array(buffer.buffer, buffer.byteOffset, buffer.byteLength)
}

export interface ExcelSheetOptions {
  columnFormats?: Array<string | undefined>
  cellFormats?: Map<string, string>
  cellDates?: boolean
}

export function cellFormatKey(rowIndex: number, columnIndex: number): string {
  return `${rowIndex}:${columnIndex}`
}

function applyNumberFormats(
  worksheet: WorkSheet,
  rows: unknown[][],
  { columnFormats = [], cellFormats }: ExcelSheetOptions,
): void {
  if (columnFormats.length === 0 && !cellFormats) return
  for (let row = 1; row < rows.length; row++) {
    const cells = rows[row] ?? []
    for (let col = 0; col < cells.length; col++) {
      const numberFormat = cellFormats?.get(cellFormatKey(row, col)) ?? columnFormats[col]
      if (!numberFormat) continue
      const cell = worksheet[`${utils.encode_col(col)}${row + 1}`] as CellObject | undefined
      if (cell?.t === "n") cell.z = numberFormat
    }
  }
}

export function sheetFromRows(rows: unknown[][], options: ExcelSheetOptions = {}): WorkSheet {
  const worksheet = utils.aoa_to_sheet(rows, { cellDates: options.cellDates ?? false })
  applyNumberFormats(worksheet, rows, options)
  return worksheet
}

export function appendSheet(
  workbook: WorkBook,
  name: string,
  rows: unknown[][],
  options: ExcelSheetOptions = {},
): WorkSheet {
  const worksheet = sheetFromRows(rows, options)
  utils.book_append_sheet(workbook, worksheet, name)
  return worksheet
}
